'use strict';

var common = require('./common');

// We pollute jquery into the global namespace... not that it's not normally local.
window.$ = require('jquery');

class SnowballGame extends require('./builder')($) {
  newStar() {
    return new Promise(function(resolve, reject) {
      var startPos = $('#snowball').offset();
      var mover = $('<img id="mover" style="position: absolute;" />');
      mover.attr('src', $('#snowball').attr('src'));
      mover.css('top', startPos.top + 'px');
      mover.css('left', startPos.left + 'px');
      mover.css('height', '50px');
      mover.appendTo($('body'));
      var finishPos = $('#hat').offset();
      var xdist = finishPos.top - startPos.top;
      var ydist = finishPos.left - startPos.left;
      $("#snowball").hide();
      $(mover).animate({
        "top": "+=" + xdist,
        "left": "+=" + ydist,
        "width": "0%"
      }, 1000, "linear", () => {
        mover.attr('src', $('#hat').attr('src'));
        mover.css('height', '100px');
        mover.css('width', 'auto');
        $("#hat").hide();
        $(mover).animate({
          "top": "+=300"
        }, 500, "linear", () => {
          $(mover).animate({
            "opacity": "0"
          }, () => {
            $("#snowball").show();
            $("#hat").show();
            $("#hat").attr('src', game.colors.shift());
            if(game.colors.length == 0) {
              game.colors = common.shuffle(game.allColors);
            }
            mover.remove();
            resolve();
          });
        });
      });
    });
  }
}


// We pollute the global namespace again such that a skin can modify the game even further.
window.game = new SnowballGame(gameOpts);

$(() => game.start());
